import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { ProgramRolesTab } from '../tabs/ProgramRolesTab';
export function RolesPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(ProgramRolesTab, {
            programId: programId
        })
    });
}
